import { useContext } from 'react';
import PageContext from '../page-context';

/**
 * nb: that wrapper around useContext will probably act as
 * a memoization layer between the context and the consumer of the hook, because context consumers all re-render when any of the value in the context changes (super costly especially since our whole component tree is generated at runtime we have to be careful of those render issues).
 * That will be solved for now by using the following good practice in the wrappers: https://github.com/facebook/react/issues/15156#issuecomment-474590693
 * - Option 1 is already in use (PageBuilder does not change and is separate, the comparator context is another kind of context, ie xstate context)
 * - Ideally use Option 2 which basically means wrapping every component in comparator-components in React.memo to make them pure components (which they should be most of the time except for those having an internal state)
 * - Option 3 has the advantage to be usable in all cases: The Wrapper Component return a memoized children with useMemo to avoid unecessary re-renders
 */
export const usePage = () => {
  return useContext(PageContext);
};
